import { Component, ViewChild, ElementRef, ChangeDetectorRef, Output, EventEmitter, Input, OnChanges, SimpleChanges, OnInit, HostListener } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, timer } from 'rxjs';

import { FocusingService } from 'src/app/shared/ui/forms/inputs/focusing.service';
import { FocusingDirective } from 'src/app/shared/ui/forms/inputs/focusing.directive';
import { UIService } from 'src/app/shared/ui/uiservice/ui.service';

import { SearchConditionComponent } from './search-condition/search-condition.component';
import { SearchTableComponent } from './search-table/search-table.component';
import { VehicleConfigurationService } from 'src/app/core/services/vehicle-services';
import { VehicleConfigurationModel, VehicleConfigurationSearchCommandModel } from 'src/app/core/models/vehicle-model/vehicle-configuration';
import { LoadingSpinnerService } from 'src/app/shared/layout/loading-spinner';
import { SecurityGroupService } from 'src/app/core/services/system-services/security-group.service';
import { SecurityGroupSecurityModel } from 'src/app/core/models/security-model/security-group-security.model';

declare var $: any;

@Component({
    selector: 'op-vehicle-configuration-search',
    templateUrl: './vehicle-configuration-search.component.html',
    providers: [UIService, FocusingService]
})
export class VehicleConfigurationSearchComponent implements OnChanges, OnInit {
    readonly VEHICLECONFIGURATION = 'VEHICLECONFIGURATION';
    readonly STATUS_DELETE = 'D';
    
    @Input() seatMap: boolean = false;
    @Input() refresh: boolean = false;
    @Input() executeFlag: boolean = true;
    @Output() onSelected = new EventEmitter<any>();
    @Output() onRefreshed = new EventEmitter();
    @ViewChild('searchConditionRef') searchConditionRef: ElementRef;
    @ViewChild('searchTableRef') searchTableRef: ElementRef;
    @ViewChild(FocusingDirective) searchResultFocusingDirective: FocusingDirective;
    @ViewChild(SearchConditionComponent) searchConditionCompoennt: SearchConditionComponent;
    @ViewChild(SearchTableComponent) searchTableComponent: SearchTableComponent;

    doubleClickSubject$ = new Subject();
    searchResults$ = new Observable<VehicleConfigurationModel[]>();
    userSecurity: SecurityGroupSecurityModel
    
    constructor(
        private store: Store<any>,
        private uiService: UIService,
        private focusingService: FocusingService,
        private vehicleConfigService: VehicleConfigurationService,
        private securityGroupService: SecurityGroupService,
        private spinnerService: LoadingSpinnerService,
        private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        if (this.executeFlag === true) {
            this.searchResults$ = this.vehicleConfigService
                .search(<VehicleConfigurationSearchCommandModel>{
                    statusCode: 'A'
                });
        }
        this.executeFlag = true;
        this.securityGroupService.userSecurityGroupSecurity
            .subscribe(userSecurity => this.userSecurity = userSecurity.find(s => s.securityCode == this.VEHICLECONFIGURATION))
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['refresh']) {
            this.refreshSearch();
        }
    }

    onSearch(command: VehicleConfigurationSearchCommandModel) {
        this.searchResults$ = this.vehicleConfigService.search(command);
        this.focusOnSearchResult();
    }

    private focusOnSearchResult() {
        this.uiService.scrollToPanel(this.store, this.searchTableRef);
        this.focusingService.focus(this.searchTableComponent.focusingDirective)
    }

    private focusOnSearchCondition() {
        this.uiService.scrollToPanel(this.store, this.searchConditionRef);
        this.focusingService.focus(this.searchConditionCompoennt.focusingDirective);
    }

    onSearchConditionPanelClick(event) {
        let searchBtn = $('#searchConditionSearchBtn')?.get(0);
        let searchBtnClicked = searchBtn?.contains(event.srcElement);
        if (searchBtnClicked) {
            this.focusOnSearchResult();
        } else {
            this.focusOnSearchCondition();
        }
    }

    onClear() {
        this.searchConditionCompoennt.initForm();
        this.searchResults$ = new Observable<VehicleConfigurationModel[]>();
        this.searchTableComponent.dataGrid.instance.clearFilter();
    }

    reSearch() {
        this.searchConditionCompoennt.doSearch();
    }

    onUpdateStatus(item) {
        this.updateStatus(item.vehicleConfigurationId, item.statusCode);
    }

    onDeleteItem(item) {
        this.updateStatus(item.vehicleConfigurationId, this.STATUS_DELETE);
    }

    onSelectedItem(item) {
        this.onSelected.emit(item);
    }

    updateStatus(vehicleConfigurationId: string, statusCode: string) {
        if (!vehicleConfigurationId || !statusCode) {
            return;
        }
        this.spinnerService.showSaving();
        this.vehicleConfigService.updateStatus(vehicleConfigurationId, statusCode)
            .subscribe(
                () => {
                    this.spinnerService.saveComplete();
                    this.searchConditionCompoennt.doSearch();
                    this.changeDetectorRef.detectChanges();
                }
            )
    }

    private refreshSearch() {
        if (this.refresh) {
            this.onClear();
            this.reSearch();
            this.onRefreshed.emit();
        }
    }

    @HostListener("window:keydown", ["$event"])
    public keyDown(event) {
        const enterKeyCode = 13;
        switch (event.keyCode) {
            case enterKeyCode:
                this.searchConditionCompoennt.doSearch();
                break;
            default:
                break;
        }
    }
}